export default function ClientPhone({ register, errors }) {
  const fieldName = "clientphone";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Phone number
      </label>
      <input
        id={fieldName}
        type="tel"
        className="wdc-field"
        placeholder="04XX XXX XXX"
        {...register(fieldName, { required: true })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
